import "core-js/modules/es6.regexp.replace";
import _regeneratorRuntime from "D:/webproject/haoyu/wms-web/WMS/node_modules/@babel/runtime/helpers/esm/regeneratorRuntime.js";
import "regenerator-runtime/runtime";
import _asyncToGenerator from "D:/webproject/haoyu/wms-web/WMS/node_modules/@babel/runtime/helpers/esm/asyncToGenerator.js";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

// import stockMessage from './stock-message'
import BulkBom from "./bulkBom";
import SecondaryProcess from '@/pages/mes/components/secondaryProcess/secondaryProcess';
import CheckPrice from '@/pages/mes/components/checkPrice/checkPrice';
import ProcessInstructionBook from '@/pages/mes/components/processInstructionBook/processInstructionBook';
import PaperPattern from '@/pages/mes/components/paperPattern/paperPattern';
import processRecord from "./process-record";
import qcReview from "./qc-review";
// import DataPrint from './data-print'
import ship from "./ship";
import cuttingBed from "./cutting-bed";
// import prenatalSamples from './prenatal-samples'
import { purchaseOrderTrackingDetails } from '@/api/MES/orderManagement.js';
export default {
  name: 'ProductionMeansCheck',
  components: {
    BulkBom: BulkBom,
    SecondaryProcess: SecondaryProcess,
    CheckPrice: CheckPrice,
    ProcessInstructionBook: ProcessInstructionBook,
    PaperPattern: PaperPattern,
    processRecord: processRecord,
    ship: ship,
    qcReview: qcReview,
    cuttingBed: cuttingBed
  },
  props: {},
  data: function data() {
    return {
      loading: false,
      bomActive: '0',
      collapseActiveNames: ['basic', 'content'],
      id: '',
      successFn: null,
      poTrackingLinkCodeVoList: [],
      // 环节编码
      poTrackingHeadVo: {
        // 基本信息
        deliveryDay: '',
        merchandiserName: '',
        printingChannelName: '',
        sheetTypeName: '',
        salesLevelName: '',
        colorName: ''
      },
      purchaseOrderSizeVo: {
        // 尺码
        dataArray: [],
        tableHead: []
      },
      bigBomVo: {
        // 大货BOM
        materialColorDataVoList: []
      },
      pdmClothDetailVo: {
        // 纸样
        tableHead: [],
        dataArray: [],
        commonAttachmentVos: []
      },
      pdmPricingWorkingProcedureVo: {
        // 核价
        chargeDetailColorVos: []
      },
      mesPurchaseSecondaryProcessVo: {
        // 二次工艺
        mesPurchaseSecondaryProcessDetailList: []
      },
      pdmProcessContentVo: {
        // 工艺指导书
        cuttingRequirementList: [],
        pdmProcessPackagingList: [],
        processRequirementList: [],
        sewingRequirementList: [],
        tailRequirementList: []
      },
      mesCuttingBedSizeVo: {
        tableHead: [],
        dataArray: []
      },
      // 裁床
      checkOrderDetailVoList: [],
      // QC尾查
      dataPrintVo: [],
      poTrackingDeliveryVo: {
        // 发货
        sizeList: [],
        sizeQtyMap: []
      },
      visible: false,
      detailIds: '',
      activeName: 'bulkbom',
      styleColorActive: '0'
    };
  },
  computed: {},
  watch: {
    visible: function visible(val) {
      if (val && this.id !== '') {
        this.getDetails();
      }
    }
  },
  created: function created() {},
  mounted: function mounted() {},
  methods: {
    getDetails: function () {
      var _getDetails = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee() {
        var result, poTrackingLinkCodeVoList, poTrackingHeadVo, purchaseOrderSizeVo, bigBomVo, mesPurchaseSecondaryProcessVo, pdmPricingWorkingProcedureVo, pdmProcessContentVo, pdmClothDetailVo, mesCuttingBedSizeVo, checkOrderDetailVoList, dataPrintVo, poTrackingDeliveryVo;
        return _regeneratorRuntime().wrap(function _callee$(_context) {
          while (1) switch (_context.prev = _context.next) {
            case 0:
              this.loading = true;
              _context.next = 3;
              return purchaseOrderTrackingDetails(this.id);
            case 3:
              result = _context.sent;
              if (result.code === 200) {
                // 节点
                poTrackingLinkCodeVoList = result.data.poTrackingLinkCodeVoList; // :class="e.state === 1 ? 'process': e.state === 2 ? 'success' : 'isWait'"
                poTrackingLinkCodeVoList.map(function (e, i) {
                  if (e.state === 1) {
                    e.currentStatus = "process";
                  } else if (e.state === 2) {
                    e.currentStatus = "success";
                  } else {
                    e.currentStatus = "wait";
                  }
                });
                // 基本信息
                poTrackingHeadVo = result.data.poTrackingHeadVo;
                purchaseOrderSizeVo = {
                  dataArray: result.data.purchaseOrderSizeVo.dataArray !== null ? result.data.purchaseOrderSizeVo.dataArray : [],
                  tableHead: result.data.purchaseOrderSizeVo.tableHead !== null ? result.data.purchaseOrderSizeVo.tableHead : []
                };
                bigBomVo = {
                  // BOM
                  materialColorDataVoList: result.data.bigBomVo.materialColorDataVoList !== null ? result.data.bigBomVo.materialColorDataVoList : []
                };
                mesPurchaseSecondaryProcessVo = {
                  // 二次工艺
                  mesPurchaseSecondaryProcessDetailList: result.data.mesPurchaseSecondaryProcessVo.mesPurchaseSecondaryProcessDetailList !== null ? result.data.mesPurchaseSecondaryProcessVo.mesPurchaseSecondaryProcessDetailList : []
                };
                pdmPricingWorkingProcedureVo = {
                  // 核价
                  chargeDetailColorVos: result.data.pdmPricingWorkingProcedureVo.chargeDetailColorVos !== null ? result.data.pdmPricingWorkingProcedureVo.chargeDetailColorVos : []
                };
                pdmProcessContentVo = {
                  // 工艺指导书
                  cuttingRequirementList: result.data.pdmProcessContentVo.cuttingRequirementList !== null ? result.data.pdmProcessContentVo.cuttingRequirementList : [],
                  pdmProcessPackagingList: result.data.pdmProcessContentVo.pdmProcessPackagingList !== null ? result.data.pdmProcessContentVo.pdmProcessPackagingList : [],
                  processRequirementList: result.data.pdmProcessContentVo.processRequirementList !== null ? result.data.pdmProcessContentVo.processRequirementList : [],
                  sewingRequirementList: result.data.pdmProcessContentVo.sewingRequirementList !== null ? result.data.pdmProcessContentVo.sewingRequirementList : [],
                  tailRequirementList: result.data.pdmProcessContentVo.tailRequirementList !== null ? result.data.pdmProcessContentVo.tailRequirementList : []
                };
                pdmClothDetailVo = {
                  // 纸样
                  tableHead: result.data.pdmClothDetailVo.tableHead !== null ? result.data.pdmClothDetailVo.tableHead : [],
                  dataArray: result.data.pdmClothDetailVo.dataArray !== null ? result.data.pdmClothDetailVo.dataArray : [],
                  commonAttachmentVos: result.data.pdmClothDetailVo.commonAttachmentVos !== null ? result.data.pdmClothDetailVo.commonAttachmentVos : []
                };
                mesCuttingBedSizeVo = {
                  // 裁床
                  tableHead: result.data.mesCuttingBedSizeVo.tableHead !== null ? result.data.mesCuttingBedSizeVo.tableHead : [],
                  dataArray: result.data.mesCuttingBedSizeVo.dataArray !== null ? result.data.mesCuttingBedSizeVo.dataArray : []
                };
                checkOrderDetailVoList = result.data.checkOrderDetailVoList !== null ? result.data.checkOrderDetailVoList : []; // QC尾查
                dataPrintVo = result.data.dataPrintVo != null ? [result.data.dataPrintVo] : []; // 资料打印
                poTrackingDeliveryVo = {
                  // 发货
                  sizeList: result.data.poTrackingDeliveryVo.sizeList !== null ? result.data.poTrackingDeliveryVo.sizeList : [],
                  sizeQtyMap: result.data.poTrackingDeliveryVo.sizeQtyMap !== null ? result.data.poTrackingDeliveryVo.sizeQtyMap : []
                };
                this.poTrackingLinkCodeVoList = poTrackingLinkCodeVoList;
                this.poTrackingHeadVo = poTrackingHeadVo;
                this.purchaseOrderSizeVo = purchaseOrderSizeVo;
                this.bigBomVo = bigBomVo;
                this.mesPurchaseSecondaryProcessVo = mesPurchaseSecondaryProcessVo;
                this.pdmPricingWorkingProcedureVo = pdmPricingWorkingProcedureVo;
                this.pdmProcessContentVo = pdmProcessContentVo;
                this.pdmClothDetailVo = pdmClothDetailVo;
                this.mesCuttingBedSizeVo = mesCuttingBedSizeVo;
                this.checkOrderDetailVoList = checkOrderDetailVoList;
                this.dataPrintVo = dataPrintVo;
                this.poTrackingDeliveryVo = poTrackingDeliveryVo;
              } else {
                this.$message({
                  message: result.msg,
                  type: "error"
                });
              }
              this.loading = false;
            case 6:
            case "end":
              return _context.stop();
          }
        }, _callee, this);
      }));
      function getDetails() {
        return _getDetails.apply(this, arguments);
      }
      return getDetails;
    }(),
    handleClick: function handleClick(tab, event) {
      console.log(tab, event);
    },
    /** 纸样/唛架下载 */handleDownload: function () {
      var _handleDownload = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee2(id) {
        return _regeneratorRuntime().wrap(function _callee2$(_context2) {
          while (1) switch (_context2.prev = _context2.next) {
            case 0:
            case "end":
              return _context2.stop();
          }
        }, _callee2);
      }));
      function handleDownload(_x) {
        return _handleDownload.apply(this, arguments);
      }
      return handleDownload;
    }(),
    isAssetTypeAnImage: function isAssetTypeAnImage(ext) {
      return ['png', 'jpg', 'jpeg', 'bmp', 'gif', 'webp', 'psd', 'svg', 'tiff'].indexOf(ext.toLowerCase()) !== -1;
    },
    /** 处理日期 */formatDate: function formatDate(date) {
      return new Date(date).toLocaleDateString().replace(/\//g, '-');
    }
  }
};